import { Helmet } from "react-helmet-async";
import Hero from "@/components/sections/Hero";
import Introduction from "@/components/sections/Introduction";
import WhoWeAre from "@/components/sections/WhoWeAre";
import GroupCompanies from "@/components/sections/GroupCompanies";
import IntegratedStrength from "@/components/sections/IntegratedStrength";
import Sectors from "@/components/sections/Sectors";
import ProfessionalApproach from "@/components/sections/ProfessionalApproach";
import WhyChooseUs from "@/components/sections/WhyChooseUs";
import ClientsStrip from "@/components/sections/ClientsStrip";
import Testimonials from "@/components/sections/Testimonials";
import FinalCTA from "@/components/sections/FinalCTA";
import ContactSection from "@/components/sections/ContactSection";

export default function Home() {
  return (
    <>
      <Helmet>
        <title>{`Salihi Group — Integrated Excellence. Trusted Growth.`}</title>
        <meta name="description" content="A diversified professional services group established 2020 in Mogadishu, Somalia. Legal, consulting, engineering, investment, mining, Oil & Gas, and workforce services under one platform." />
        <link rel="canonical" href="https://www.salihigroup.com/" />
        <meta property="og:url" content="https://www.salihigroup.com/" />
      </Helmet>
      <div id="top" />
      <Hero />
      <Introduction />
      <WhoWeAre />
      <GroupCompanies />
      <IntegratedStrength />
      <Sectors />
      <ProfessionalApproach />
      <WhyChooseUs />
      <ClientsStrip />
      <Testimonials />
      <FinalCTA />
      <ContactSection />
    </>
  );
}
